// For inheritance: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/create
// For calling parent methods: http://stackoverflow.com/questions/11854958/how-to-call-a-parent-method-from-child-class-in-javascript

// Warning: this code works with coordinates in format latitude, longitude (y, x). Take it into account when using the values (especially coordinates).

/** ******************************************************************************* */
/* Common shared constants and class for map instances                            */
/** ******************************************************************************* */
const t = typeof translation !== 'undefined' ? translation : {};

Bingo.Map = {};
Bingo.Map.LOADING_SELECTOR = 'map-loading';
Bingo.Map.LOADING_FAILED_SELECTOR = 'map-loading-failed';
Bingo.Map.MODAL_CONTENT_SELECTOR_PREFIX = 'map-modal-content-';
Bingo.Map.MAP_CONTAINER_SELECTOR_PREFIX = 'map-outter-';

Bingo.Map.DEFAULT_STYLES = [
    {
        featureType: 'administrative',
        elementType: 'labels.text.fill',
        stylers: [
            {
                color: '#444444',
            },
        ],
    },
    {
        featureType: 'landscape',
        elementType: 'all',
        stylers: [
            {
                color: '#f2f2f2',
            },
            {
                lightness: '2',
            },
        ],
    },
    {
        featureType: 'landscape.natural.terrain',
        elementType: 'geometry.fill',
        stylers: [
            {
                lightness: '7',
            },
            {
                gamma: '4.19',
            },
        ],
    },
    {
        featureType: 'poi',
        elementType: 'all',
        stylers: [
            {
                visibility: 'off',
            },
        ],
    },
    {
        featureType: 'poi.park',
        elementType: 'geometry',
        stylers: [
            {
                lightness: '-16',
            },
            {
                gamma: '2.64',
            },
            {
                visibility: 'on',
            },
            {
                saturation: '-7',
            },
        ],
    },
    {
        featureType: 'poi.park',
        elementType: 'labels',
        stylers: [
            {
                visibility: 'on',
            },
            {
                lightness: '12',
            },
            {
                saturation: '29',
            },
            {
                gamma: '1.00',
            },
            {
                hue: '#00ff2d',
            },
        ],
    },
    {
        featureType: 'poi.park',
        elementType: 'labels.icon',
        stylers: [
            {
                visibility: 'off',
            },
        ],
    },
    {
        featureType: 'road',
        elementType: 'all',
        stylers: [
            {
                saturation: -100,
            },
            {
                lightness: 45,
            },
        ],
    },
    {
        featureType: 'road',
        elementType: 'geometry.fill',
        stylers: [
            {
                saturation: '0',
            },
            {
                lightness: '0',
            },
            {
                gamma: '3.36',
            },
            {
                weight: '2.29',
            },
        ],
    },
    {
        featureType: 'road',
        elementType: 'labels.text.fill',
        stylers: [
            {
                lightness: '-28',
            },
            {
                saturation: '-17',
            },
            {
                gamma: '0.95',
            },
        ],
    },
    {
        featureType: 'road.highway',
        elementType: 'all',
        stylers: [
            {
                visibility: 'simplified',
            },
        ],
    },
    {
        featureType: 'road.arterial',
        elementType: 'labels.icon',
        stylers: [
            {
                visibility: 'off',
            },
        ],
    },
    {
        featureType: 'transit',
        elementType: 'all',
        stylers: [
            {
                visibility: 'off',
            },
        ],
    },
    {
        featureType: 'water',
        elementType: 'all',
        stylers: [
            {
                color: '#39b6e9',
            },
            {
                visibility: 'on',
            },
        ],
    },
    {
        featureType: 'water',
        elementType: 'geometry.fill',
        stylers: [
            {
                saturation: '-24',
            },
            {
                lightness: '30',
            },
            {
                gamma: '1.86',
            },
            {
                weight: '1.34',
            },
        ],
    },
    {
        featureType: 'water',
        elementType: 'geometry.stroke',
        stylers: [
            {
                gamma: '1.34',
            },
            {
                lightness: '3',
            },
            {
                visibility: 'off',
            },
        ],
    },
];
Bingo.Map.DEFAULT_LOCATION = {lat: 49.720000, long: 6.131935};
Bingo.Map.DEFAULT_ZOOM = 10;
Bingo.Map.MODE_SEARCH_LIST = 'search';
Bingo.Map.MODE_POSITION_SELECT = 'position_select';
Bingo.Map.MODE_MARKER_LIST = 'marker_list';
Bingo.Map.DEFAULT_BOUNDING_BOX = {
    ne: new google.maps.LatLng(50.250000, 6.600000),
    sw: new google.maps.LatLng(49.400000, 5.600000),
};

Bingo.Map.Marker = {};
Bingo.Map.Marker.COLOR = {
    blue: '#5188B4',
    grey: '#CBCBCB',
    brown: '#BD946B',
    property: '#CBCBCB',
};
Bingo.Map.Marker.RADIUS_OPACITY = 0.08;
Bingo.Map.Marker.RADIUS_OPACITY_HOVER = 0.2;
Bingo.Map.Marker.RADIUS_BORDER = 3;

Bingo.Map.default = null;
Bingo.Map.instances = {};
Bingo.Map.initCallbacks = {};

Bingo.Map.markerIconTypes = {
    bus_station: '/src/images/markers/bus_station.png?{{buildVersion}}',
    train_station: '/src/images/markers/train_station.png?{{buildVersion}}',
    gas_station: '/src/images/markers/gas_station.png?{{buildVersion}}',
    atm: '/src/images/markers/atm.png?{{buildVersion}}',
    restaurant: '/src/images/markers/restaurant.png?{{buildVersion}}',
    store: '/src/images/markers/shopping_mall.png?{{buildVersion}}',
    school: '/src/images/markers/school.png?{{buildVersion}}',
    medical: '/src/images/markers/hospital.png?{{buildVersion}}',
};

Bingo.Map.defaultPlaceType = null;

Bingo.Map.FALLBACK_RADIUS = 4;

Bingo.Map.ORIGIN_PAGE_MODE = {
    DEMAND: 'demand',
    DEMAND_LIST: 'demand-list',
    NEW_OFFER: 'new-offer',
    OFFER_LIST: 'offer-list',
    PROJECT: 'project',
};


Bingo.Map.PositionSelectionCircleOptions = {
    strokeColor: Bingo.Map.Marker.COLOR.blue,
    strokeWeight: Bingo.Map.Marker.RADIUS_BORDER,
    fillColor: Bingo.Map.Marker.COLOR.blue,
    fillOpacity: Bingo.Map.Marker.RADIUS_OPACITY,
    clickable: true,
    editable: true,
    zIndex: 10,
    suppressUndo: true,
    cursor: null, // to prevent irrelevant drag cursor
};
Bingo.Map.PositionSelectionPolygonOptions = {
    strokeColor: Bingo.Map.Marker.COLOR.blue,
    strokeWeight: Bingo.Map.Marker.RADIUS_BORDER,
    fillColor: Bingo.Map.Marker.COLOR.blue,
    fillOpacity: Bingo.Map.Marker.RADIUS_OPACITY,
    clickable: true,
    editable: true,
    zIndex: 10,
    suppressUndo: true,
    cursor: null, // to prevent irrelevant drag cursor
};
Bingo.Map.PositionSelectionMarkerOptions = {
    icon: {
        url: '/src/images/markers/property.png?{{buildVersion}}',
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(20, 42),
        size: new google.maps.Size(40, 48),
        scaledSize: new google.maps.Size(40, 48),
    },
};
Bingo.Map.PositionSelectionTargetOptions = {
    icon: {
        url: '/src/images/markers/target.svg?{{buildVersion}}',
        size: new google.maps.Size(32, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(16, 16),
        scaledSize: new google.maps.Size(32, 32),
    },
    draggable: true,
};

Bingo.Map.MarkerListInfoModes = {
    info: '',
    info2: 'small',
};

Bingo.Map.LoadingInfoBox = Cookies.get('hidden-images-search-page') ? `<div class=" offer-minipreview-panel not-loaded"><img src="/src/images/skeleton-offer-preview-without-image.svg" alt="${t.offerLoading}"/></div>` : `<div class=" offer-minipreview-panel not-loaded"><img src="/src/images/skeleton-offer-preview.svg" alt="${t.offerLoading}"/></div>`;
Bingo.Map.LoadingInfoBoxBig = `<div class=" offer-minipreview-panel not-loaded"><img src="/src/images/skeleton-offer-preview-big.svg" alt="${t.offerLoading}"/></div>`;
Bingo.Map.LoadingInfoBoxSmall = `<div class=" offer-minipreview-panel not-loaded"><img src="/src/images/skeleton-offer-preview-small.svg" alt="${t.offerLoading}"/></div>`;


Bingo.Map.InfoBoxOptions = {
    boxClass: 'A-mapInfoBox',
    disableAutoPan: false,
    maxWidth: 0,
    pixelOffset: new google.maps.Size(-210, -350),
    zIndex: 10,
    boxStyle: {
        opacity: 1,
        margin: '40px 40px 0px 10px',
    },
    closeBoxMargin: '0px',
    closeBoxURL: '',
    infoBoxClearance: new google.maps.Size(1, 1),
    isHidden: false,
    pane: 'floatPane',
};

Bingo.Map.PositionSelectionDrawToolElement = '.js-drawingTools';
Bingo.Map.PositionSelectionDrawCircle = '.js-drawingTools-circle';
Bingo.Map.PositionSelectionDrawPolygon = '.js-drawingTools-polygon';
Bingo.Map.PositionSelectionDrawClear = '.js-drawingTools-clear';
Bingo.Map.ClearLocalitiesConfirmModalId = 'clearLocalitiesConfirm';
